"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledLabel = exports.StyledContainer = exports.StyledCheckboxGroup = exports.StyledCheckbox = exports.Container = void 0;
var _react = _interopRequireDefault(require("react"));
var _ykbStyledComponents = _interopRequireWildcard(require("../ykb-styled-components"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
var StyledLabel = exports.StyledLabel = _ykbStyledComponents.default.span.withConfig({
  componentId: "ykb-ui__sc-1pk6cbh-0"
})(["font-size:", ";font-weight:", ";line-height:", ";"], function (props) {
  return props.$theme.checkbox.label.fontSize;
}, function (props) {
  return props.$theme.checkbox.label.fontWeight;
}, function (props) {
  return props.$theme.checkbox.label.lineHeight;
});
var StyledCheckbox = exports.StyledCheckbox = _ykbStyledComponents.default.label.attrs({
  className: 'ykb-ui-checkbox'
}).withConfig({
  componentId: "ykb-ui__sc-1pk6cbh-1"
})(["margin-right:", ";cursor:pointer;width:fit-content;", " &:hover .", "-inner{border-color:", ";}.", "-input:focus + .", "-inner{border-color:", ";", ";}.", "{white-space:nowrap;cursor:pointer;outline:none;display:inline-block;position:relative;line-height:0;vertical-align:bottom;width:auto !important;& + ", "{padding-left:", ";padding-right:", ";cursor:pointer;}&-inner{&:after{transform:translate(-50%,-65%) rotate(45deg);position:absolute;left:50%;top:50%;display:table;width:6px;height:10px;border:2px solid ", ";border-top:0;border-left:0;content:' ';}position:relative;top:0;left:0;display:inline-block;width:", ";height:", ";border-width:1px;border-style:solid;border-radius:", ";border-color:", ";background-color:", ";}&-input{position:absolute;left:0;cursor:pointer;opacity:0;top:0;bottom:0;right:0;}}", " ", " .", "-disabled{& + span{color:", ";cursor:not-allowed !important;}.", "-inner{border-color:", " !important;background-color:", ";&:after{border-color:", ";}}.", "-inner-input{cursor:default;}&:hover{cursor:not-allowed;.", "-inner{border-color:", ";}.", "-input{cursor:not-allowed;}}&.", "-checked{&:hover{.", "-inner{border-color:", ";}}.", "-inner{background-color:", ";border-color:", ";&:after{border-color:", ";}}}}"], function (props) {
  return props.theme.checkbox.labelMargin;
}, function (props) {
  return props.vertical && (0, _ykbStyledComponents.css)(["display:table;margin-bottom:10px;"]);
}, function (props) {
  return props.prefixCls;
}, function (props) {
  return props.theme.checkbox.check.hoverBorderColor;
}, function (props) {
  return props.prefixCls;
}, function (props) {
  return props.prefixCls;
}, function (props) {
  return props.theme.checkbox.check.hoverBorderColor;
}, function (props) {
  return !props.checked && (0, _ykbStyledComponents.css)(["box-shadow:", ";"], function (props) {
    return props.theme.checkbox.check.focusBoxShadow;
  });
}, function (props) {
  return props.prefixCls;
}, StyledLabel, function (props) {
  return props.theme.checkbox.labelPadding;
}, function (props) {
  return props.theme.checkbox.labelPadding;
}, function (props) {
  return props.theme.checkbox.check.status.default.backgroundColor;
}, function (props) {
  return props.theme.checkbox.check.size;
}, function (props) {
  return props.theme.checkbox.check.size;
}, function (props) {
  return props.theme.checkbox.check.borderRadius;
}, function (props) {
  return props.theme.checkbox.check.status.default.borderColor;
}, function (props) {
  return props.theme.checkbox.check.status.default.backgroundColor;
}, function (props) {
  return props.indeterminate && (0, _ykbStyledComponents.css)([".", "-inner{background-color:", ";border-color:", ";}.", "-inner:after{top:50%;left:50%;width:", ";height:", ";border-radius:", ";background-color:", ";border:0;transform:translate(-50%,-50%) scale(1);opacity:1;content:' ';}.", "-disabled .", "-inner:after{background-color:", " !important;border-color:", " !important;}"], function (props) {
    return props.prefixCls;
  }, function (props) {
    return props.theme.checkbox.check.status.default.backgroundColor;
  }, function (props) {
    return props.theme.checkbox.check.status.default.borderColor;
  }, function (props) {
    return props.prefixCls;
  }, function (props) {
    return props.theme.checkbox.check.indeterminateSize;
  }, function (props) {
    return props.theme.checkbox.check.indeterminateSize;
  }, function (props) {
    return props.theme.checkbox.check.indeterminateBorderRadius;
  }, function (props) {
    return props.theme.checkbox.check.status.checked.iconColor;
  }, function (props) {
    return props.prefixCls;
  }, function (props) {
    return props.prefixCls;
  }, function (props) {
    return props.theme.checkbox.check.status.disabled.indeterminateColor;
  }, function (props) {
    return props.theme.checkbox.check.status.disabled.borderColor;
  });
}, function (props) {
  return props.checked && (0, _ykbStyledComponents.css)(["&:hover{.", "-inner{border-color:", ";}}.", "-inner{border-color:", ";background-color:", ";&:after{transform:rotate(45deg);position:absolute;left:6px;top:2px;display:table;width:6px;height:10px;border:2px solid ", ";border-top:0;border-left:0;content:' ';}}"], function (props) {
    return props.prefixCls;
  }, function (props) {
    return props.theme.checkbox.check.status.checked.borderColor;
  }, function (props) {
    return props.prefixCls;
  }, function (props) {
    return props.theme.checkbox.check.status.checked.borderColor;
  }, function (props) {
    return props.theme.checkbox.check.status.checked.backgroundColor;
  }, function (props) {
    return props.theme.checkbox.check.status.checked.iconColor;
  });
}, function (props) {
  return props.prefixCls;
}, function (props) {
  return props.theme.checkbox.check.status.disabled.textColor;
}, function (props) {
  return props.prefixCls;
}, function (props) {
  return props.theme.checkbox.check.status.disabled.borderColor;
}, function (props) {
  return props.theme.checkbox.check.status.disabled.backgroundColor;
}, function (props) {
  return props.theme.checkbox.check.status.disabled.backgroundColor;
}, function (props) {
  return props.prefixCls;
}, function (props) {
  return props.prefixCls;
}, function (props) {
  return props.theme.checkbox.check.status.disabled.borderColor;
}, function (props) {
  return props.prefixCls;
}, function (props) {
  return props.prefixCls;
}, function (props) {
  return props.prefixCls;
}, function (props) {
  return props.theme.checkbox.check.status.disabled.borderColor;
}, function (props) {
  return props.prefixCls;
}, function (props) {
  return props.theme.checkbox.check.status.disabled.backgroundColor;
}, function (props) {
  return props.theme.checkbox.check.status.disabled.border;
}, function (props) {
  return props.theme.checkbox.check.status.disabled.iconColor;
});
var Container = exports.Container = function Container(_ref) {
  var children = _ref.children,
    theme = _ref.theme,
    className = _ref.className,
    prefixCls = _ref.prefixCls,
    checked = _ref.checked,
    disabled = _ref.disabled,
    indeterminate = _ref.indeterminate,
    style = _ref.style,
    cls = _ref.cls,
    vertical = _ref.vertical;
  var prefix = prefixCls ? prefixCls : className.split(' ').pop();
  return /*#__PURE__*/_react.default.createElement(StyledCheckbox, {
    theme: theme,
    prefixCls: prefix,
    checked: checked,
    disabled: disabled,
    indeterminate: indeterminate,
    style: style,
    className: cls,
    vertical: vertical
  }, children(prefix));
};
var StyledContainer = exports.StyledContainer = (0, _ykbStyledComponents.default)(Container).withConfig({
  componentId: "ykb-ui__sc-1pk6cbh-2"
})([""]);
var StyledCheckboxGroup = exports.StyledCheckboxGroup = _ykbStyledComponents.default.div.withConfig({
  componentId: "ykb-ui__sc-1pk6cbh-3"
})(["&[disabled='true']{cursor:not-allowed;", "{pointer-events:none;> span:first-child{& + span{color:", ";cursor:not-allowed !important;}> span[class*='-inner']{border-color:", " !important;background-color:", ";&:after{border-color:", ";}}input[class*='-input']{cursor:not-allowed !important;}}> span[class*='-checked']{> span[class*='-inner']{background-color:", ";border-color:", ";&:after{border-color:", ";}}}}}"], StyledCheckbox, function (props) {
  var _props$theme$checkbox, _props$theme$checkbox2, _props$theme$checkbox3, _props$theme$checkbox4;
  return (_props$theme$checkbox = props.theme.checkbox) === null || _props$theme$checkbox === void 0 ? void 0 : (_props$theme$checkbox2 = _props$theme$checkbox.check) === null || _props$theme$checkbox2 === void 0 ? void 0 : (_props$theme$checkbox3 = _props$theme$checkbox2.status) === null || _props$theme$checkbox3 === void 0 ? void 0 : (_props$theme$checkbox4 = _props$theme$checkbox3.disabled) === null || _props$theme$checkbox4 === void 0 ? void 0 : _props$theme$checkbox4.textColor;
}, function (props) {
  var _props$theme$checkbox5, _props$theme$checkbox6, _props$theme$checkbox7, _props$theme$checkbox8;
  return (_props$theme$checkbox5 = props.theme.checkbox) === null || _props$theme$checkbox5 === void 0 ? void 0 : (_props$theme$checkbox6 = _props$theme$checkbox5.check) === null || _props$theme$checkbox6 === void 0 ? void 0 : (_props$theme$checkbox7 = _props$theme$checkbox6.status) === null || _props$theme$checkbox7 === void 0 ? void 0 : (_props$theme$checkbox8 = _props$theme$checkbox7.disabled) === null || _props$theme$checkbox8 === void 0 ? void 0 : _props$theme$checkbox8.borderColor;
}, function (props) {
  var _props$theme$checkbox9, _props$theme$checkbox10, _props$theme$checkbox11, _props$theme$checkbox12;
  return (_props$theme$checkbox9 = props.theme.checkbox) === null || _props$theme$checkbox9 === void 0 ? void 0 : (_props$theme$checkbox10 = _props$theme$checkbox9.check) === null || _props$theme$checkbox10 === void 0 ? void 0 : (_props$theme$checkbox11 = _props$theme$checkbox10.status) === null || _props$theme$checkbox11 === void 0 ? void 0 : (_props$theme$checkbox12 = _props$theme$checkbox11.disabled) === null || _props$theme$checkbox12 === void 0 ? void 0 : _props$theme$checkbox12.backgroundColor;
}, function (props) {
  var _props$theme$checkbox13, _props$theme$checkbox14, _props$theme$checkbox15, _props$theme$checkbox16;
  return (_props$theme$checkbox13 = props.theme.checkbox) === null || _props$theme$checkbox13 === void 0 ? void 0 : (_props$theme$checkbox14 = _props$theme$checkbox13.check) === null || _props$theme$checkbox14 === void 0 ? void 0 : (_props$theme$checkbox15 = _props$theme$checkbox14.status) === null || _props$theme$checkbox15 === void 0 ? void 0 : (_props$theme$checkbox16 = _props$theme$checkbox15.disabled) === null || _props$theme$checkbox16 === void 0 ? void 0 : _props$theme$checkbox16.backgroundColor;
}, function (props) {
  var _props$theme$checkbox17, _props$theme$checkbox18, _props$theme$checkbox19, _props$theme$checkbox20;
  return (_props$theme$checkbox17 = props.theme.checkbox) === null || _props$theme$checkbox17 === void 0 ? void 0 : (_props$theme$checkbox18 = _props$theme$checkbox17.check) === null || _props$theme$checkbox18 === void 0 ? void 0 : (_props$theme$checkbox19 = _props$theme$checkbox18.status) === null || _props$theme$checkbox19 === void 0 ? void 0 : (_props$theme$checkbox20 = _props$theme$checkbox19.disabled) === null || _props$theme$checkbox20 === void 0 ? void 0 : _props$theme$checkbox20.backgroundColor;
}, function (props) {
  var _props$theme$checkbox21, _props$theme$checkbox22, _props$theme$checkbox23, _props$theme$checkbox24;
  return (_props$theme$checkbox21 = props.theme.checkbox) === null || _props$theme$checkbox21 === void 0 ? void 0 : (_props$theme$checkbox22 = _props$theme$checkbox21.check) === null || _props$theme$checkbox22 === void 0 ? void 0 : (_props$theme$checkbox23 = _props$theme$checkbox22.status) === null || _props$theme$checkbox23 === void 0 ? void 0 : (_props$theme$checkbox24 = _props$theme$checkbox23.disabled) === null || _props$theme$checkbox24 === void 0 ? void 0 : _props$theme$checkbox24.border;
}, function (props) {
  var _props$theme$checkbox25, _props$theme$checkbox26, _props$theme$checkbox27, _props$theme$checkbox28;
  return (_props$theme$checkbox25 = props.theme.checkbox) === null || _props$theme$checkbox25 === void 0 ? void 0 : (_props$theme$checkbox26 = _props$theme$checkbox25.check) === null || _props$theme$checkbox26 === void 0 ? void 0 : (_props$theme$checkbox27 = _props$theme$checkbox26.status) === null || _props$theme$checkbox27 === void 0 ? void 0 : (_props$theme$checkbox28 = _props$theme$checkbox27.disabled) === null || _props$theme$checkbox28 === void 0 ? void 0 : _props$theme$checkbox28.iconColor;
});